export var ReadMoreVariant;
(function (ReadMoreVariant) {
    ReadMoreVariant["Default"] = "default";
    ReadMoreVariant["Promo"] = "promo";
})(ReadMoreVariant || (ReadMoreVariant = {}));
